// extracted by mini-css-extract-plugin
module.exports = {"page":"RealName_page__1NfMv","required":"RealName_required__3l4kB","authButton":"RealName_authButton__3TGnv","agreement":"RealName_agreement__oEgu6"};